import { render } from "./NotificationBar.vue?vue&type=template&id=7aa86162"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=7aa86162&lang=css"

import exportComponent from "/tmp/builds/1syD-sny/0/plataforma/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__